import React, { useState } from 'react';
import InvestForm from '../components/sections/InvestForm';
import InvestmentHistory from '../components/sections/InvestmentHistory';

export default function Invest() {
  const [refresh, setRefresh] = useState(0);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div>
          <h2 className="page-title"><span className="title-accent">↑</span> Invest</h2>
          <div className="page-subtitle">Open a new position — 50% USDT + 50% Token2</div>
        </div>
      </div>

      <InvestForm onSuccess={() => setRefresh((v) => v + 1)} />

      <div className="mt-6" key={refresh}>
        <InvestmentHistory />
      </div>
    </div>
  );
}
